import { Injectable } from '@angular/core';
import { CanDeactivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ProfileComponent } from '../components/profile/profile.component';
import { UserAuthService } from '../services/user-auth.service';

export interface CanComponentDeactivate {
  canDeactivate: (
    nextState: RouterStateSnapshot,
  ) => boolean | Observable<boolean> | Promise<boolean>;
}

@Injectable({
  providedIn: 'root',
})
export class ProfileGuard implements CanDeactivate<ProfileComponent> {
  constructor(private readonly userAuthService: UserAuthService) {}
  // Prefix unused parameters with _  This tells the linter that the parameters are intentionally unused:
  // to keep the method signature for interface compatibility but don't use all parameters.
  canDeactivate(component: ProfileComponent): boolean | Observable<boolean> | Promise<boolean> {
    const isNewUser = this.userAuthService.getUserFirstTimeLoginStatus();

    if (isNewUser) {
      // Show modal for new user
      component.openAlertModal();
      return false; // prevent navigation until user confirms
    }

    // For existing users, use component's own canDeactivate logic
    if (!component || typeof component.canDeactivate !== 'function') {
      return true;
    }

    return component.canDeactivate();
  }
}
